// CONVENTION formatFoo -> string

import { BigNumber } from '@ethersproject/bignumber'

export function formatNumber(value: BigNumber | Number): string {
    return ''
}
